import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { ABILITIES, systemLabelKey } from "../../../catalogs/characterSystemCatalog";
import Skill from "../../../models/Skill";
import DraggableModal from "../../layout/DraggableModal/DraggableModal";

const AddSkillModal = ({ isOpen, onClose, onAddSkill, formData, setFormData, maxSkillRanks = 0 }) => {
  const { t } = useTranslation();
  const [rankError, setRankError] = useState("");
  const rankInputRef = useRef(null);
  useEffect(() => {
    if (isOpen) setRankError("");
  }, [isOpen]);
  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name === "playerSkillPoints") setRankError("");
    setFormData((previous) => name === "isClassSkill"
      ? { ...previous, isClassSkill: checked, manualIsClassSkill: checked }
      : { ...previous, [name]: type === "checkbox" ? checked : value });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (Number(formData.playerSkillPoints) > maxSkillRanks) {
      setRankError(t("skills.ranksLimit", { level: maxSkillRanks }));
      rankInputRef.current?.focus();
      return;
    }
    onAddSkill(formData);
    setFormData(new Skill({ id: "", name: "", modifier: 0, abilityId: "strength", playerSkillPoints: 0, isClassSkill: false }));
    onClose();
  };

  return isOpen && (
    <DraggableModal isVisible={isOpen} onClose={onClose} headerText={t("skills.editTitle")}>
      <form onSubmit={handleSubmit} noValidate>
        <p className="skill-form-hint">{t("skills.hint")}</p>
        <label className="skill-form-field">{t("skills.skillName")}<input type="text" name="name" value={formData.name || ""} onChange={handleChange} /></label>
        <label className="skill-form-field">{t("skills.linkedAbility")}
          <select name="abilityId" value={formData.abilityId || "strength"} onChange={handleChange}>
            {ABILITIES.map((ability) => <option key={ability.id} value={ability.id}>{t(systemLabelKey("abilities", ability.id))}</option>)}
          </select>
        </label>
        <label className="skill-form-field">{t("skills.otherBonus")}<input type="number" name="modifier" value={formData.modifier} onChange={handleChange} /></label>
        <label className="skill-form-field">{t("skills.ranks")}
          <input
            ref={rankInputRef}
            type="number"
            name="playerSkillPoints"
            value={formData.playerSkillPoints}
            min="0"
            max={maxSkillRanks}
            step="1"
            aria-invalid={Boolean(rankError)}
            aria-describedby="skill-ranks-error"
            onChange={handleChange}
          />
          <span id="skill-ranks-error" className="skill-form-error" role="alert">{rankError}</span>
        </label>
        <label className="skill-form-checkbox"><input type="checkbox" name="isClassSkill" checked={formData.isClassSkill} onChange={handleChange} />{t("skills.classSkill")}</label>
        <button type="submit">{t("skills.save")}</button>
      </form>
    </DraggableModal>
  );
};

export default AddSkillModal;
